import { Box } from "@mui/material";
import NavPageSelector from "./NavPageSelector";
import { PHONE_SCREEN, THIN_SCROLLBAR, WIDE_SCREEN } from "../utils/layout";

export default function NavigationPanel({
  collapsed,
  onToggleCollapse,
  children,
}) {
  return (
    <Box
      className="map-overlay map-overlay--left"
      sx={{
        position: "fixed",
        top: "20px",
        left: "20px",
        display: "flex",
        gap: 2,
        alignItems: "flex-start",
        zIndex: 1000,
        pointerEvents: "none",
        [`@media ${PHONE_SCREEN}`]: {
          top: "12px",
          left: "12px",
          right: "12px",
        },
      }}
    >
      <Box
        className="glass-panel"
        sx={{
          width: "280px",
          pointerEvents: "auto",
          px: 1.5,
          py: "6px", // folded, matches the right panel tab bar (48px)
          boxSizing: "border-box",
          overflowY: "auto",
          ...THIN_SCROLLBAR,
          // Stops above the map bar in the bottom-left corner.
          maxHeight: "calc(100vh - 98px)",
          [`@media not all and ${WIDE_SCREEN}`]: {
            maxHeight: "calc(100vh - 124px)",
          },
          // Phones: full width, above the map bar and the bottom sheet.
          [`@media ${PHONE_SCREEN}`]: {
            width: "100%",
            maxHeight: "calc(100vh - 180px)",
          },
        }}
      >
        <NavPageSelector
          collapsed={collapsed}
          onToggleCollapse={onToggleCollapse}
        >
          {children}
        </NavPageSelector>
      </Box>
    </Box>
  );
}
